<template>
  <section :class="!reportMode ? 'mt-3' : ''">
    <div v-for="(chart, i) in formattedCharts" :key="i" :class="!reportMode ? 'my-5' : ''">
      <h4 v-if="chart.title">{{ chart.title }}</h4>
      <div v-if="!chart.showTable">
        <div>
          <div>
            <div v-if="!reportMode" class="mx-1 button_container">
              <b-button
                variant="default"
                :class="{ selected: valueYMin != null || valueYMax != null }"
                @click="$bvModal.show('modal-valueYChart')"
              >
                <font-awesome-icon icon="list-ol" />
              </b-button>
              <b-button
                v-if="filter.sampling == '60'"
                variant="default"
                :class="{ selected: isDurationCurve }"
                @click="setDurationCurve"
              >
                <font-awesome-icon icon="clock" />
              </b-button>
              <b-button v-if="hasElasticData && i == 0" variant="primary" v-b-modal.modal-production>
                Produzione
              </b-button>
              <b-button v-if="i == 0" variant="default" @click="tableButtonClick(chart, i)">
                <img title="Tabella" src="/static/icons/icon-25.png" width="16" />
              </b-button>
              <b-button
                v-if="i == 0"
                variant="default"
                :class="{ selected: thresholds.length > 0 }"
                @click="openModalThreshold()"
              >
                <font-awesome-icon icon="bars" />
              </b-button>
              <b-button
                v-if="i == 0"
                variant="default"
                class="btn average-button"
                :class="{ selected: filter.enableTruncatedAverage }"
                @click="$bvModal.show('modal-average')"
              >
                <font-awesome-icon icon="scissors" />
                <font-awesome-icon icon="circle" class="dot" style="color: green" v-if="truncatedAverageApplied" />
              </b-button>
              <b-button v-if="filter.compare == 'no' && !reportpopupMode" variant="default" @click="splitChart()">
                <img v-if="!filter.split" title="Split" src="/static/icons/icon-3.png" width="16" />
                <div v-if="filter.split" class="apex-custom-button icon-network" style="color: black"></div>
              </b-button>
              <b-button
                v-if="!filter.split"
                variant="default"
                :class="{ selected: isAggregateMode }"
                @click="aggregateButton(chart, i)"
              >
                <img title="Visualizza misure" src="/static/icons/fx.png" width="16" />
              </b-button>
              <b-button variant="default" v-if="type == 'bar' && showStackFun" @click="UnstackedColumns">
                <img title="Unstacked columns" src="/static/icons/chart-column.png" width="16" />
              </b-button>
              <b-button variant="default" v-if="type == 'bar' && showStackFun" @click="stackedButtonHandle">
                <img title="Stacked columns" src="/static/icons/chart-column-stacked.png" width="16" />
              </b-button>
              <b-button variant="default" v-if="type == 'bar' && showStackFun" @click="StackedPercent">
                <img title="Stacked Percent" src="/static/icons/icon-percent.png" width="16" />
              </b-button>

              <b-button
                v-if="filter.mode === 'MEASURES'"
                variant="default"
                :class="{ selected: isEnergyMode }"
                @click="measuresButtonClick(chart, i)"
              >
                <font-awesome-icon icon="fa-solid fa-bolt" />
              </b-button>
              <b-button
                v-if="filter.mode === 'MEASURES'"
                variant="default"
                :class="{ selected: filter.costs }"
                @click="euroButtonClick(chart, i)"
              >
                <font-awesome-icon icon="fa-solid fa-euro-sign" />
              </b-button>
              <b-button
                v-if="filter.mode === 'MEASURES'"
                variant="default"
                :class="{ selected: filter.co2 }"
                @click="co2ButtonClick(chart, i)"
              >
                <font-awesome-icon icon="fa-solid fa-smog" />
              </b-button>
              <b-button
                v-if="filter.mode === 'MEASURES'"
                variant="default"
                :class="{ selected: filter.tep }"
                @click="tepButtonClick(chart, i)"
              >
                <font-awesome-icon icon="fa-solid fa-fire" />
              </b-button>

              <!-- rolling button -->
              <b-button
                v-if="isIndicators && filter.sampling === 'm'"
                variant="default"
                @click="rollingButtonClick(chart, i)"
              >
                <img v-if="!isRolling" title="Visualizza misure" src="/static/icons/rolling.svg" width="16" />
                <img v-if="isRolling" title="Visualizza misure" src="/static/icons/rolling-disable.svg" width="16" />
              </b-button>
            </div>
          </div>
        </div>

        <div v-if="!reportMode" class="d-flex">
          <div
            style="width: 100%"
            class="mr-4"
            :style="{ height: checkChartHeight }"
            :ref="chart.id"
            :id="chart.id"
          ></div>
          <thresholds-table
            style="width: 500px"
            v-if="thresholds.length > 0"
            :thresholds="thresholds"
            :data="data"
            :are-thresholds-plotted="!isDurationCurve"
          >
          </thresholds-table>
          <div v-if="isAggregateMode" style="width: 500px; font-size: 14px">
            <table class="table">
              <thead v-if="!isPersonalizeAggregateMode">
                <th scope="col" style="white-space: nowrap">U.M.</th>
                <th scope="col" style="white-space: nowrap">f(x)</th>
                <th scope="col" style="white-space: nowrap">Valore</th>
              </thead>
              <thead v-else>
                <th scope="col" style="white-space: nowrap">Channel</th>
                <th scope="col" style="white-space: nowrap">f(x)</th>
              </thead>
              <tbody v-if="!isPersonalizeAggregateMode">
                <tr scope="row" v-for="(measure, index) in uniqueMeasures" :key="index">
                  <td style="white-space: nowrap">{{ measure }}</td>
                  <td style="white-space: nowrap">
                    <select v-model="measuresAggregateMode[index]" class="aggregate-selection-selector form-control">
                      <option v-for="(type, meaIndex) in availableMeasureTypes" :value="type.value" :key="meaIndex">
                        {{ type.label }}
                      </option>
                    </select>
                  </td>
                  <td v-if="measuresAggregateMode[index] == 'mul'" style="white-space: nowrap">
                    <input type="number" class="aggregate-input-number form-control" v-model="multiplier" />
                  </td>
                </tr>
                <tr>
                  <td></td>
                  <td>
                    <b-button variant="primary" @click="isPersonalizeAggregateMode = true">Personalizza</b-button>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <tr scope="row" v-for="(range, index) in getColumnNamesWithMeasure" :key="index">
                  <td class="p-1">{{ range.name }} ({{ range.measure }}):</td>
                  <td class="d-flex p-1">
                    <select v-model="rangeAggregateModes[index]" class="aggregate-selection-selector form-control p-1">
                      <option value="">Nessuna</option>
                      <option v-for="(type, index) in availableMeasureTypes" :value="type.value" :key="index">
                        {{ type.label }}
                      </option>
                    </select>
                    <input
                      v-if="rangeAggregateModes[index] == 'mul'"
                      type="number"
                      class="aggregate-input-number form-control p-1"
                      v-model="multiplierAggregateModes[index]"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <b-button variant="primary" @click="isPersonalizeAggregateMode = false">Chiudi</b-button>
                  </td>
                  <td>
                    <b-button variant="primary" @click="handleCreateFxData()">Applica</b-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-else :style="{ height: checkChartHeight }" :ref="chart.id" :id="chart.id"></div>
      </div>
      <div v-else>
        <ChartTable
          ref="refChartTable"
          :propSwitchColumns="propSwitchColumns"
          @download="download"
          @downloadTable="downloadTable"
          @close="tableClosed(chart)"
          @toggleRolling="toggleRolling()"
          :chart="chart"
          :reportMode="reportMode"
          :filter="filter"
          :series="tableSeries"
          :dates="tableDates"
          :maxMonth="maxMonth"
          :id="chart.id"
        />
      </div>
      <b-modal id="modal-customize" title="Personalizza" @ok="createFxData(null)">
        <div
          v-for="(range, index) in getColumnNamesWithMeasure"
          class="aggregate-selection d-flex align-items-center"
          :key="index"
        >
          <div class="aggregate-selection-label mr-2">{{ range.name }} ({{ range.measure }}):</div>
          <select v-model="rangeAggregateModes[index]" class="aggregate-selection-selector form-control width-150 mr-2">
            <option value="">Nessuna</option>
            <option v-for="(type, index) in availableMeasureTypes" :value="type.value" :key="index">
              {{ type.label }}
            </option>
          </select>
        </div>
      </b-modal>
    </div>

    <b-modal id="modal-average" ref="modalAverage" size="lg" title="Applica Smart Filter" :hide-footer="true">
      <form role="form" ref="form" class="needs-validation" novalidate @submit.prevent="checkAverageForm()">
        <div class="mb-3">
          <label class="label-control">
            <input type="checkbox" v-model="average.enableTruncatedAverage" />
            Applica Smart Filter
          </label>
        </div>
        <label class="label-control d-block">Percentuale elementi esclusi (max 45%)</label>
        <b-input-group class="mt-3">
          <template #append>
            <b-input-group-text>%</b-input-group-text>
          </template>
          <input
            type="number"
            class="form-control average-number"
            min="0"
            max="45"
            v-model="average.truncatedAverageExclude"
            :disabled="!average.enableTruncatedAverage"
            required
          />
        </b-input-group>

        <label class="label-control">%</label>
        <div class="mt-3">
          <label class="label-control d-block">Moltiplicatore</label>
          <input
            type="number"
            class="form-control average-number"
            min="1"
            v-model="average.truncatedAverageMultiplier"
            :disabled="!average.enableTruncatedAverage"
            required
          />
        </div>
        <div class="d-flex justify-content-end">
          <b-btn variant="secondary" @click="$bvModal.hide('modal-average')">Annulla</b-btn>
          <button type="submit" class="btn btn-primary ml-2">Applica</button>
        </div>
      </form>
    </b-modal>

    <b-modal id="modal-threshold" ref="modalThreshold" size="lg" title="Applica soglia" :hide-footer="true">
      <div class="d-flex align-items-end my-3" v-for="(item, index) in thresholdsCopy" :key="index">
        <div class="mr-3">
          <label class="label-control d-block">Nome soglia</label>
          <input type="text" class="form-control" v-model="item.name" />
        </div>
        <div class="mr-4">
          <label class="label-control d-block">Valore soglia</label>
          <input type="number" class="form-control" v-model="item.value" />
        </div>
        <b-btn class="threshold-button mr-2" @click="newThreshold()">
          <font-awesome-icon icon="plus" />
        </b-btn>
        <b-btn v-if="thresholdsCopy.length > 1" class="threshold-button" @click="deleteThreshold(index)">
          <font-awesome-icon icon="times" />
        </b-btn>
      </div>
      <div class="d-flex justify-content-end mt-5">
        <b-btn variant="secondary" class="mr-2" @click="$bvModal.hide('modal-threshold')">Annulla</b-btn>
        <b-btn variant="primary" class="mr-2" @click="removeThresholds()">Rimuovi soglie</b-btn>
        <b-btn variant="primary" @click="addThresholds()">Applica</b-btn>
      </div>
    </b-modal>

    <b-modal id="modal-production" size="lg" title="Dati di produzione" @ok="addProductionData">
      <b-row>
        <b-col>
          <label>Tipo dato</label>
        </b-col>
        <b-col>
          <label>Valore</label>
        </b-col>
      </b-row>
      <b-row v-for="(item, idx) in elasticConditions" v-bind:key="idx" class="mb-2">
        <b-col cols="6">
          <v-select
            append-to-body
            v-on:option:selected="loadElasticValues(item, idx)"
            :options="elasticColumns"
            :multiple="false"
            v-model="item.field"
          ></v-select>
        </b-col>
        <b-col cols="4">
          <v-select append-to-body :options="elasticValues[item.field]" :multiple="false" v-model="item.value">
          </v-select>
          <!--<span v-if="isLoadingElasticValues" style="color:#999; font-size:10px">Caricamento in corso...</span>-->
        </b-col>
        <b-col cols="2">
          <b-btn variant="secondary" v-if="elasticConditions.length > 1" @click="removeCondition(idx)">
            <font-awesome-icon icon="times" />
          </b-btn>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col>
          <b-alert show="!elasticConditionsPass" variant="warning">Compilare tutti i campi</b-alert>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col>
          <b-btn variant="secondary" @click="addElasticCondition()"> Aggiungi condizione </b-btn>
        </b-col>
      </b-row>
    </b-modal>

    <ValueYChartModal @reload="setValueYChart" />
  </section>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4lang_it_IT from "@amcharts/amcharts4/lang/it_IT";
import NeedUpdateMixin from "../../NeedUpdateMixin";
import utils from "../../../../utilsMixin";
import { debounce } from "lodash";
import { makeid } from "../../helpers";
import { startRender, finishRender } from "../../../../helpers/printReady";
import ChartTable from "../../Table";
import moment from "moment";
import XLSX from "xlsx";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

import ThresholdsTable from "./ThresholdsTable.vue";
import ValueYChartModal from "./ValueYChartModal.vue";

import { mapState, mapGetters, mapActions } from "vuex";

export default {
  name: "LineChart",
  mixins: [NeedUpdateMixin, utils],
  props: {
    badgeType: {
      type: String,
      required: false,
      default: "channels",
    },
    filter: {
      type: Object,
      required: true,
    },
    type: {
      type: String,
      required: false,
      default: "line",
    },
    reportMode: {
      type: Boolean,
      required: false,
      default: false,
    },
    reportpopupMode: {
      required: false,
      default: false,
    },
    reportProps: {
      required: false,
      type: Object,
    },
    maxMonth: {
      required: false,
      type: Object,
    },
    selectedSources: {
      required: false,
      type: Array,
    },
  },
  components: { ChartTable, vSelect, ThresholdsTable, ValueYChartModal },
  data() {
    return {
      newCalculatedData: undefined,
      dates: [],
      seriesColorIndex: 0,
      tableSeries: [],
      tooltipData: [],
      previousBarState: null,
      charts: [],
      incomplete: [], // Warning messages
      area: true, // Show area
      isEnergyMode: true,

      isAggregateMode: false,
      isRolling: false,
      measuresAggregateMode: ["sum", "sum", "sum", "sum"],
      rangeAggregateModes: [],
      availableMeasureTypes: [
        {
          value: "sum",
          label: "Somma",
        },
        {
          value: "avg",
          label: "Media",
        },
        {
          value: "mul",
          label: "Moltiplica",
        },
      ],
      vectorNamesWithMeasures: [],

      colors: this.$store.state.colors,
      timeDiff: null,
      series: [],
      mus: [],
      channels: [],
      previousData: {},
      previousTime: {},
      dateFormat: {
        m: "MM/YYYY",
        w: "DD/MM/YYYY",
        d: "DD/MM/YYYY",
        60: "DD/MM/YYYY",
      },
      currentPeriodDates: [],
      previousPeriodDates: [],
      dateAxis: null,
      yAxis: {},
      data: null,
      percentageData: false,
      isStacked: false,
      axesLabelTogglePer: "",
      elasticColumns: [],
      elasticConditions: [{}],
      elasticValues: {},
      isLoadingElasticValues: false,
      elasticConditionsPass: true,
      truncatedAverageApplied: false,
      average: {
        enableTruncatedAverage: null,
        truncatedAverageExclude: 20,
        truncatedAverageMultiplier: 20,
      },
      thresholds: [],
      thresholdsCopy: [],
      multiplier: 1,
      isPersonalizeAggregateMode: false,
      multiplierAggregateModes: [],
      propSwitchColumns: false,
      copyChartResponse: {},
      copyChartParams: {},
      isDurationCurve: false,
      valueYMin: null,
      valueYMax: null,
      maxMonthChanged: false,
    };
  },
  async mounted() {
    this.reload();
    // this.elasticColumns = await this.$store.dispatch("elastic/loadColumns")
  },
  methods: {
    async setValueYChart(min, max) {
      this.valueYMin = min;
      this.valueYMax = max;

      await this.reload();
    },
    async setDurationCurve() {
      this.isDurationCurve = !this.isDurationCurve;
      this.reload();
    },
    handleCreateFxData() {
      let error = 0;
      this.rangeAggregateModes.forEach((item, index) => {
        if (item == "mul") {
          if (!this.multiplierAggregateModes[index]) {
            error++;
          }
        }
      });
      if (error == 0) {
        this.createFxData(null);
      } else if (error == 1) {
        this.$notify({
          type: "error",
          text: "Inserire correttamente il moltiplicatore",
          title: "Errore",
        });
      } else {
        this.$notify({
          type: "error",
          text: "Inserire correttamente i moltiplicatori",
          title: "Errore",
        });
      }
    },
    removeThresholds() {
      this.thresholds = [];
      this.thresholdsCopy = [];
      this.$refs.modalThreshold.hide();
    },
    deleteThreshold(index) {
      this.thresholdsCopy[index].value = "ToBeRemoved";
      this.thresholdsCopy = this.thresholdsCopy.filter((item) => item.value != "ToBeRemoved");
    },
    addThresholds() {
      let error = 0;
      this.thresholdsCopy.forEach((item) => {
        if (!item.name || !item.value) {
          error++;
        }
      });
      if (error > 0) {
        this.$notify({
          type: "error",
          text: "Inserire correttamente tutti i dati",
          title: "Errore",
        });
        return;
      }
      this.thresholdsCopy = this.thresholdsCopy.sort((a, b) => a.value - b.value);

      this.thresholds = [...this.thresholdsCopy].map((t) => {
        if (typeof t === "string") {
          t.value = parseFloat(t);
        }
        return t;
      });

      this.$refs.modalThreshold.hide();
      this.reload();
    },
    newThreshold() {
      this.thresholdsCopy.push({ name: "", value: null });
    },
    openModalThreshold() {
      if (this.thresholdsCopy.length < 1) {
        this.thresholdsCopy.push({ name: "", value: null });
      }
      this.$bvModal.show("modal-threshold");
    },
    toggleRolling() {
      this.filter.rolling = !this.filter.rolling;
      this.reload();
    },
    applyAverage() {
      if (this.average.enableTruncatedAverage) {
        this.filter.enableTruncatedAverage = true;
        this.filter.truncatedAverageExclude = this.average.truncatedAverageExclude / 100;
        this.filter.truncatedAverageMultiplier = parseFloat(this.average.truncatedAverageMultiplier);
      } else {
        this.filter.enableTruncatedAverage = false;
        this.filter.truncatedAverageExclude = null;
        this.filter.truncatedAverageMultiplier = null;
      }
      this.reload();
      this.$refs.modalAverage.hide();
    },
    checkAverageForm() {
      if (!this.$refs.form.checkValidity()) {
        this.$refs.form.classList.add("was-validated");
        this.$notify({
          type: "error",
          text: "Compilare i campi obbligatori",
          title: "Errore",
        });
        return;
      }
      this.applyAverage();
    },
    addProductionData() {
      this.filter.elasticConditions = [...this.elasticConditions];
      this.reload();
    },
    removeCondition(idx) {
      this.elasticConditions.splice(idx, 1);
    },
    addElasticCondition() {
      this.elasticConditionsPass =
        this.elasticConditions.filter((e) => {
          return !(e.field && e.value);
        }).length == 0;
      if (this.elasticConditionsPass) this.elasticConditions.push({});
    },
    async loadElasticValues(item, idx) {
      this.isLoadingElasticValues = true;
      this.elasticValues[item.field] = await this.$store.dispatch("elastic/loadValues", item.field);
      this.elasticValues = { ...this.elasticValues };

      this.isLoadingElasticValues = false;
    },
    channelName(channel) {
      let siteName = "";
      this.sites.forEach((site) => {
        site[this.badgeType].forEach((entity) => {
          if (this.compareEntityCode(entity, channel)) {
            channel = this.getName(entity);
            siteName = site.name;
          }
        });
      });
      return this.sites.length > 1 ? " " + siteName : "";
    },
    getName(entity) {
      let name = null;
      switch (this.badgeType) {
        case "indicators":
          name = entity.formula ? entity.formula.name : "";
          break;
        case "channels":
          name = entity.name ? entity.name : "";
          break;
      }
      return name;
    },
    compareEntityCode(entity, channel) {
      let result = null;
      switch (this.badgeType) {
        case "indicators":
          result = entity.id === channel;
          break;
        case "channels":
          result = entity.code === channel;
          break;
      }
      return result;
    },
    StackedPercent() {
      if (this.percentageData) {
        return;
      }
      this.percentageData = true;
      let data = this.data;
      const dataByPer = {
        columns: data.columns,
        mus: data.mus,
        sources: data.sources,
        values: [],
      };
      let items = this.data.values;
      items.forEach((ele) => {
        let dateArray = [ele[0]];
        let sum = 0;
        for (var i = 1; i < ele.length; i++) {
          sum = sum + ele[i];
        }
        for (var j = 1; j < ele.length; j++) {
          let percent = (ele[j] / sum) * 100;
          dateArray.push(percent);
        }
        dataByPer.values.push(dateArray);
      });
      let chart = this.charts[0];
      this.disposeAllSeries(chart);
      chart.chart.yAxes.values[0].max = 100;
      this.axesLabelTogglePer = chart.chart.yAxes.values[0].title.text;
      chart.chart.yAxes.values[0].title.text = "%";
      this.createSeries(dataByPer, chart.chart, false, {}, false);
      if (this.reportpopupMode) {
        this.filter.actionButtons = "StackedPercent";
      }
    },
    UnstackedColumns() {
      this.percentageData = false;
      this.isStacked = false;
      let chart = this.charts[0];
      this.disposeAllSeries(chart);
      this.createSeries(this.data, chart.chart, false, {}, false);
      chart.chart.yAxes.values[0].max = undefined;
      chart.chart.yAxes.values[0].title.text = this.axesLabelTogglePer;
    },
    stackedButtonHandle() {
      if (this.isStacked) {
        return;
      }
      this.isStacked = true;
      this.percentageData = false;
      let chart = this.charts[0];
      this.disposeAllSeries(chart);
      this.createSeries(this.data, chart.chart, false, {}, false);
      chart.chart.yAxes.values[0].max = undefined;
      if (this.reportpopupMode) {
        this.filter.actionButtons = "stackedButtonHandle";
      }
    },
    async reload() {
      this.$store.commit("loading");
      //assuming reportProps contains the same format of data as returned by getChartData
      // const data = this.reportpopupMode? reportProps: await this.getChartData();

      const data = await this.getChartData();

      if (data && data.values) {
        data.values = data.values.map((val) => {
          return val.map((v, vIndex) => {
            if (vIndex == 0) {
              return v;
            }
            if (!v) {
              return v;
            }
            if (v < 0.0000001 && v >= 0) {
              return 0.0;
            }
            if (v <= 0 && v > -0.0000001) {
              return 0.0;
            }
            return v;
          });
        });
      }
      /**
       * For monthly reports
       */
      if (this.maxMonth && this.filter.sampling == "m" && Array.isArray(data.values)) {
        data.values = data.values.map((item) => {
          if (!this.maxMonth.isBefore(moment(item[0]))) {
            return item;
          }
          return [item[0]];
        });
      }

      if (!data) {
        this.unload();
        this.$store.commit("stopLoading");
        return;
      }

      this.data = data;
      let error = 0;

      if (this.data) {
        if (this.isDurationCurve) {
          for (let i = 1; i < this.data.values.length; i++) {
            let values = this.data.values.map((item) => item[i]);
            values = values.sort((a, b) => b - a);

            this.data.values.forEach((item, index) => {
              item[i] = values[index];
            });
          }
        } else {
          this.thresholds.forEach((item) => {
            if (this.data.columns.includes(item.name)) {
              error++;
            }
            if (error > 0) {
              this.$notify({
                type: "error",
                text: "Nome soglia già esistente",
                title: "Errore",
              });
              return;
            }
            this.data.columns.push(item.name);
            this.data.mus.push(this.data.mus[0]);
            this.data.sources.push(item.name);
            this.data.values.forEach((value) => {
              value.push(parseFloat(item.value));
              return value;
            });
          });
        }
      }

      if (this.isAggregateMode) {
        this.isAggregateMode = false;
        this.$store.commit("stopLoading");
        return;
      }

      /**
       * Set truncated average values from response
       */
      this.average.truncatedAverageExclude = this.data.truncatedAverageExclude * 100;
      this.average.truncatedAverageMultiplier = parseFloat(this.average.truncatedAverageMultiplier);
      this.average.enableTruncatedAverage = this.data.truncatedAverageApplied;

      this.truncatedAverageApplied = this.data.truncatedAverageApplied;
      this.average = { ...this.average };

      this.unload();
      if (this.filter.split) {
        let splitChartArray = [];
        for (let i = 0; i < data.sources.length; i++) {
          let splitChart = {};
          for (let key in data) {
            if (Array.isArray(data[key]) && data[key].length) {
              if (key == "columns") {
                splitChart[key] = [data[key][0], data[key][i + 1]];
              } else if (key == "values") {
                splitChart.values = data.values.map((ele) => {
                  return [ele[0], ele[i + 1]];
                });
              } else {
                splitChart[key] = [data[key][i]];
              }
            } else {
              splitChart[key] = data[key];
            }
          }
          splitChart.title = data.columns[i + 1];
          splitChartArray.push(splitChart);
        }
        splitChartArray.forEach((chartData) => {
          const chartId = makeid();
          let chartItem = {
            id: chartId,
            toolbar: { open: false },
            showTable: false,
            title: chartData.title,
          };
          this.charts.push(chartItem);

          this.$nextTick(() => {
            this.makeChart(chartItem, chartId, chartData, true);
          });
        });
      } else {
        const chartId = makeid();
        let chartItem = {
          id: chartId,
          toolbar: { open: false },
          showTable: false,
        };
        this.charts = [chartItem];

        this.$nextTick(() => {
          this.makeChart(chartItem, chartId, data, false);
        });
      }

      this.$store.commit("stopLoading");
    },
    makeChart(chartItem, chartId, data, skipSeriesColor) {
      let chart = am4core.create(chartId, am4charts.XYChart);

      // Track async rendering so the Puppeteer print service can wait until
      // every chart has finished drawing before generating the PDF.
      startRender();
      let renderSettled = false;
      const settleRender = () => {
        if (renderSettled) return;
        renderSettled = true;
        finishRender();
      };
      chart.events.on("ready", settleRender);
      // Safety net: never leave a render pending forever if "ready" never fires.
      setTimeout(settleRender, 8000);

      chart.language.locale = am4lang_it_IT;

      chart.numberFormatter.numberFormat = "#.0";
      if (this.reportMode) {
        chart.fontSize = 11;
      }

      chartItem.chart = chart;
      let dateAxis = (dateAxis = chart.xAxes.push(new am4charts.DateAxis()));

      dateAxis.cursorTooltipEnabled = false;
      dateAxis.groupData = true;

      if (this.filter.sampling == "1") dateAxis.groupCount = 10080;
      if (this.filter.sampling == "15") dateAxis.groupCount = 8928;
      if (this.filter.sampling == "60") dateAxis.groupCount = 8800;

      if (this.filter.sampling == "d" || this.filter.sampling == "m") {
        dateAxis.groupData = false;
      }

      dateAxis.renderer.labels.template.adapter.add("text", (label, target, key) => {
        if (target.dataItem.value) {
          let labelValue = target.dataItem.value;
          return this.getDateAxisLabelFormat(labelValue);
        }
      });

      let sampling = this.filter.sampling;
      if (sampling == "1" || sampling == "15" || sampling == "60") {
        // you can set grid intervals with below minGridDistance
        dateAxis.renderer.minGridDistance = 40;

        // rotate labels as in minutes that are lot of labels.
        dateAxis.renderer.labels.template.rotation = -45;
        dateAxis.renderer.labels.template.horizontalCenter = "right";
        dateAxis.renderer.labels.template.verticalCenter = "middle";
      }

      // if chart is bar, set its spacing
      if (this.type == "bar") {
        dateAxis.renderer.minGridDistance = 40;
        dateAxis.renderer.cellStartLocation = 0.2;
        dateAxis.renderer.cellEndLocation = 0.8;
        dateAxis.renderer.labels.template.rotation = -45;
        dateAxis.renderer.labels.template.horizontalCenter = "right";
        dateAxis.renderer.labels.template.verticalCenter = "middle";
      }

      if (!this.reportMode) {
        chart.scrollbarX = new am4core.Scrollbar();
        chart.scrollbarX.parent = chart.bottomAxesContainer;
        chart.exporting.menu = new am4core.ExportMenu();
      }

      chart.cursor = new am4charts.XYCursor();
      chart.legend = new am4charts.Legend();
      chart.legend.maxHeight = 150;
      chart.legend.scrollable = true;
      if (this.type == "line") {
        chart.legend.markers.template.disabled = true;
      }
      if (this.reportMode && this.type == "bar") {
        var markerTemplate = chart.legend.markers.template;
        markerTemplate.width = 10;
        markerTemplate.height = 10;
      }

      // chart.cursor.maxTooltipDistance = 0;
      chart.series.clear();
      this.yAxis = {};
      let oppositeAxis = true;
      this.channels = [];
      data.mus.forEach((mu, index) => {
        if (!this.yAxis[mu]) {
          let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
          if (this.valueYMin != null || this.valueYMax != null) {
            valueAxis.strictMinMax = true;
            valueAxis.min = this.valueYMin;
            valueAxis.max = this.valueYMax;
          }

          valueAxis.name = data.columns[index + 1];
          valueAxis.title.text = data.vectors[index] + "\xa0\xa0\xa0" + `[[${mu}]]`; //`${data.columns[index + 1]}  [[${mu}]]`;
          valueAxis.title.fontWeight = 600;
          valueAxis.renderer.opposite = !oppositeAxis;
          valueAxis.fill = am4core.color(this.colors[index % this.colors.length]);
          oppositeAxis = !oppositeAxis;
          valueAxis.cursorTooltipEnabled = false;
          this.yAxis[mu] = valueAxis;
          valueAxis.renderer.labels.template.adapter.add("text", (label, target, key) => {
            if (target.dataItem.value) {
              let labelValue = Number(target.dataItem.value);
              if (labelValue > 100) {
                return labelValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'");
              } else if (labelValue < 1) {
                let num = labelValue.toFixed(4);
                return num.toString().replace(".", ",");
              } else {
                let num = labelValue.toFixed(2);
                return num.toString().replace(".", ",");
              }
            } else if (target.dataItem.value == 0) {
              return 0;
            }
          });
        }
        this.channels.push({
          name: data.columns[index + 1],
          mu,
        });
      });

      if (this.isComparing) {
        // create comparing series...
        this.createSeries(this.previousData, chart, true, data, this.type == "bar" ? true : false);
      }
      this.createSeries(data, chart, false, this.previousData, skipSeriesColor);

      let chartIndex = this.charts.findIndex((c) => c.chartId == chartId);
      if (chartIndex >= 0) {
        this.charts[chartIndex].chart = chart;
      }
      this.checkChartForReports();
      if (this.isRecheckAggregateMode) {
        this.aggregateButton();
        this.isRecheckAggregateMode = false;
      }
    },
    vectorName(vector) {
      return this.$store.getters["vectors/getName"](vector);
    },
    createSeries(data, chart, isComparing, compareData, skipSeriesColor) {
      for (let index = 0; index < data.sources.length; index++) {
        let source = data.sources[index];

        let series = chart.series.push(this.type == "line" ? new am4charts.LineSeries() : new am4charts.ColumnSeries());
        let mu = data.mus[index];
        series.minBulletDistance = 15;

        if (this.type == "line") {
          var bullet = series.bullets.push(new am4charts.CircleBullet());
          bullet.circle.strokeWidth = 1;
          bullet.circle.radius = 2;
          bullet.circle.fill = am4core.color("#fff");
          var bullethover = bullet.states.create("hover");
          bullethover.properties.scale = 2;
        }

        if (this.percentageData || this.isStacked) {
          series.stacked = true;
        }
        if (this.type == "line") {
          var seriesColor = this.colors[skipSeriesColor ? Math.floor(Math.random() * 10) : index % this.colors.length];
        } else {
          var seriesColor = this.colors[this.seriesColorIndex];
          this.seriesColorIndex += 1;
        }

        if (this.type == "line") {
          if (this.isDurationCurve && this.thresholds.length > 0) {
            series.propertyFields.stroke = "lineColor";
            series.propertyFields.fill = "lineColor";
            series.fillOpacity = 0.5;
          } else {
            series.stroke = am4core.color(seriesColor);
          }
        } else {
          series.strokeWidth = 0;
          series.stroke = am4core.color(seriesColor);
          series.columns.template.fill = am4core.color(seriesColor);
        }

        let seriesName = "";
        let channel = source;
        let siteName = this.channelName(channel);

        if (isComparing) {
          if (this.filter.sampling == "m") {
            let fromMonth = this.previousPeriodDates[0].split("-");
            let toMonth = this.previousPeriodDates[this.previousPeriodDates.length - 1].split("-");

            let result1 = fromMonth[0];
            let result2 = toMonth[0];
            fromMonth = fromMonth[1] + "/" + fromMonth[0];
            toMonth = toMonth[1] + "/" + toMonth[0];
            if (result1 < 10 && result2 < 10) {
              seriesName = !isComparing
                ? data.columns[index + 1] + siteName
                : data.columns[index + 1] + siteName + " " + "0" + fromMonth + " - " + "0" + toMonth;
            }
            if (result1 < 10 && result2 >= 10) {
              seriesName = !isComparing
                ? data.columns[index + 1] + siteName
                : data.columns[index + 1] + siteName + " " + "0" + fromMonth + " - " + toMonth;
            }
            if (result1 >= 10 && result2 >= 10) {
              seriesName = !isComparing
                ? data.columns[index + 1] + siteName
                : data.columns[index + 1] + siteName + " " + fromMonth + " - " + toMonth;
            }
          } else {
            let fromDate = this.previousPeriodDates[0].split("-").reverse().join("/");
            let toDate = this.previousPeriodDates[this.previousPeriodDates.length - 1].split("-").reverse().join("/");
            seriesName = !isComparing
              ? data.columns[index + 1] + siteName
              : data.columns[index + 1] + siteName + " " + fromDate + " - " + toDate;
          }
        } else {
          seriesName = data.columns[index + 1] + siteName;
        }

        series.dataFields.valueY = isComparing ? source + "*" : source;

        series.meta = {
          siteName,
          source,
          cleanName: data.columns[index + 1],
          comparing: isComparing,
          indicatorAverages: data.indicatorAverages,
          numerators: data.indicatorNumerators ? data.indicatorNumerators.map((e) => e[index]) : [],
          denominators: data.indicatorDenominators ? data.indicatorDenominators.map((e) => e[index]) : [],
        };
        series.name = seriesName;
        series.dataFields.dateX = "date";
        series.groupFields.valueY = "average";
        series.tooltip.label.propertyFields.fill = am4core.color("#FFFFFF");
        series.yAxis = this.yAxis[mu];
        series.connect = false;
        series.autoGapCount = 3;
        series.tooltip.getFillFromObject = false;
        series.tooltip.autoTextColor = false;

        series.adapter.add("tooltipText", (text, target) => {
          try {
            let tooltipData = target.tooltipDataItem.dataContext;
            let tooltipComparing = tooltipData && tooltipData.isComparing ? tooltipData.isComparing : false;
            let openValue = target.tooltipDataItem.values.valueY.value;
            let valueY = openValue ? openValue : tooltipData ? tooltipData.value : 0;
            let name = tooltipData && tooltipData.name ? tooltipData.name : false;
            var formattedValueY = valueY;

            if (isNaN(valueY)) {
              valueY = 0.0;
            }

            formattedValueY = this.formatPrecision(valueY, 4);
            let strokeColor = target.stroke.hex;
            let dateFormat = this.getTooltipFormat(tooltipComparing);
            var text = `${dateFormat}  \n [${strokeColor}]● [/] ${name} [[${tooltipData.unit}]]  [bold]${formattedValueY}[/]`;
            if (!tooltipComparing && tooltipData.comparePercentage) {
              let diff = Number(tooltipData.comparePercentage);
              if (this.filter.mode === "INDICATORS") {
                if (diff > 0) {
                  text += " [red bold] ⬆" + diff + "%";
                } else {
                  text += " [green bold] ⬇" + diff + "%";
                }
              } else {
                if (tooltipData.source == "channels") {
                  if (diff > 0) {
                    text += " [red bold] ⬆" + diff + "%";
                  } else {
                    text += " [green bold] ⬇" + diff + "%";
                  }
                } else if (tooltipData.source == "parameters") {
                  if (diff > 0) {
                    text += " [green bold] ⬆" + diff + "%";
                  } else {
                    text += " [red bold] ⬇" + diff + "%";
                  }
                }
              }
            }
            if (this.percentageData) {
              return text + "%";
            }
            return text;
          } catch (error) {
            console.log(error.message);
          }
        });

        if (isComparing) {
          series.strokeDasharray = "3,4";
        }

        series.tooltip.label.fill = am4core.color("black");
        var series_data = [];

        if (this.type == "line") {
          series.legendSettings.labelText = `[bold ${seriesColor}] ▬ [/]  {name}`;
        }
        try {
          data.values.forEach((item, valueIndex) => {
            var valueYname = isComparing ? source + "*" : source;
            var dataItem = {};
            dataItem.unit = data.mus[index];
            dataItem.isComparing = isComparing;
            // if (channels=EL)
            var checkChannels = this.filter.channels.find((ele) => ele == source);
            var checkParameters = this.filter.parameters.find((ele) => ele == source);
            // if(this.filters.channels)
            // dataItem.source = "channel"
            if (checkChannels == source) {
              dataItem.source = "channels";
            }
            if (checkParameters == source) {
              dataItem.source = "parameters";
            }

            dataItem.value = item[index + 1];

            if (isComparing) {
              let date = compareData.values[valueIndex] ? new Date(compareData.values[valueIndex][0]) : null;
              dataItem.date = date;
              dataItem.name = seriesName;
              dataItem.previousDate = new Date(item[0]);

              dataItem[valueYname] = item[index + 1];
              series_data.push(dataItem);
            } else {
              dataItem.date = new Date(item[0]);
              dataItem.name = seriesName;

              if (compareData.values) {
                try {
                  let v = item[index + 1];
                  let previous = compareData.values[valueIndex][index + 1];
                  let diff = ((v - previous) / previous) * 100;
                  dataItem.comparePercentage = !Number.isFinite(diff) ? 0 : diff.toFixed(2);
                } catch (error) {
                  console.log(error.message);
                }
              }

              dataItem[valueYname] = item[index + 1];

              if (this.isDurationCurve && this.thresholds.length > 0) {
                const durationColors = ["#ed2b2b", "#ed922b", "#d6ed2b", "#2bedc0", "#2b2eed"];

                let colorsSelected = [];

                colorsSelected.push(durationColors[0]);
                durationColors.forEach((col, colIdx) => {
                  if (colIdx == 0) {
                    return;
                  }
                  let division = durationColors.length / this.thresholds.length;
                  if (division < Math.floor(division) + 0.7) {
                    division = Math.floor(division);
                  } else {
                    division = Math.ceil(division);
                  }

                  if (colIdx % division == 0) {
                    colorsSelected.push(col);
                  }
                });

                if (!colorsSelected.includes(durationColors[durationColors.length - 1])) {
                  colorsSelected.push(durationColors[durationColors.length - 1]);
                }

                let thresholds = [...this.thresholds];

                if (thresholds.length > 1) {
                  thresholds = thresholds.sort((a, b) => b.value - a.value);
                }

                thresholds.forEach((th, thIndex) => {
                  if (!dataItem.lineColor && dataItem.value > parseFloat(th.value)) {
                    if (thIndex <= colorsSelected.length - 1) {
                      dataItem.lineColor = am4core.color(colorsSelected[thIndex]);
                    }
                  }
                });

                if (!dataItem.lineColor) {
                  dataItem.lineColor = am4core.color(colorsSelected[colorsSelected.length - 1]);
                }
              }

              series_data.push(dataItem);
            }
          });
        } catch (error) {
          console.log(error);
        }
        series.data = series_data;
      }
      this.formattedCharts.forEach((chart) => {
        setTimeout(() => {
          chart.chart.zoom({ start: 0, end: 1 });
        }, 100);
      });
    },
    async getChartData() {
      let params = _.cloneDeep(this.filter);
      if (this.average.enableTruncatedAverage === false) {
        this.filter.enableTruncatedAverage = false;
      }

      if (params.sampling != "m" && this.maxMonth) {
        if (moment(params.fromDate).format("MM-YYYY") == moment(params.toDate).format("MM-YYYY")) {
          let fromDateObject = {};
          fromDateObject.date = moment(params.fromDate).toObject().date;
          fromDateObject.months = parseInt(moment(this.maxMonth).format("M")) - 1;
          fromDateObject.years = moment(this.maxMonth).format("YYYY");
          params.fromDate = moment(fromDateObject).format("YYYY-MM-DD");

          params.toDate = moment(params.fromDate).endOf("month").format("YYYY-MM-DD");
        }
      }

      if (
        this.reportMode &&
        this.maxMonth &&
        params.sampling == "m" &&
        moment(params.fromMonth, "MM-YYYY").format("MM") == "01" &&
        moment(params.toMonth, "MM-YYYY").format("MM") == "12"
      ) {
        params.fromMonth = "01-" + this.maxMonth.format("YYYY");
        params.compareFromMonth = `01-${parseInt(this.maxMonth.format("YYYY")) - 1}`;
        params.toMonth = "12-" + this.maxMonth.format("YYYY");
      }

      if (this.isRolling) {
        params.rolling = true;
      }

      if (this.isIndicators) {
        params.indicators = [...params.channels];
        delete params.channels;
        let indicators = params.indicators ? params.indicators.length : true;
        if (!indicators) {
          return false;
        }
      }

      if (!this.isIndicators) {
        let channels = params.channels ? params.channels.length : true;
        let parameters = params.parameters ? params.parameters.length : true;
        let check = channels || parameters;
        let isPayload = !!check;
        if (!isPayload) {
          return false;
        }
      }

      if (!this.reportMode) {
        params.sources = [];
      }

      if (this.reportMode && params.rolling && this.isIndicators && params.sampling == "m" && this.maxMonth) {
        params.toMonth = moment(this.maxMonth).format("M-yyyy").toString();
        params.fromMonth = moment(this.maxMonth).subtract(1, "years").format("M-yyyy").toString();
      }

      if (params.sampling && params.sampling == "y") {
        params.compare = "no";
      }

      params.keepOriginalSourceName = false;

      let response = null;

      let isValueNew = true;
      let invalidate = false;
      let isSourceNew = true;

      let selectedSourcesCounter = 0;

      if (this.selectedSources && this.selectedSources.length > 0) {
        this.selectedSources.forEach((ss) => {
          if (ss.measures) {
            selectedSourcesCounter += ss.measures.length;
          }
        });
      }

      if (
        this.$store.state.charts.lastFetchedChartParameters &&
        this.$store.state.charts.lastFetchedChartParameters.sources &&
        this.$store.state.charts.lastFetchedChartParameters.sources.length == selectedSourcesCounter
      ) {
        isSourceNew = false;
      }

      //check to avoid starting "charts/get"
      if ((!isSourceNew && this.copyChartResponse && this.copyChartParams) || this.maxMonthChanged) {
        let data = null;
        if (!this.copyChartResponse.values) {
          data = { ...this.copyChartResponse[0] };
        } else {
          data = { ...this.copyChartResponse };
        }

        if (params.compare != "no" && this.copyChartResponse.values) {
          invalidate = true;
        }

        if (params.compare != this.copyChartParams.compare) {
          invalidate = true;
        }

        if (params.compareFromMonth != this.copyChartParams.compareFromMonth) {
          invalidate = true;
        }

        if (params.compareFromDate != this.copyChartParams.compareFromDate) {
          invalidate = true;
        }

        if (params.compare == "no" && this.copyChartResponse.length) {
          invalidate = true;
        }

        if (params.sampling != data.sampling) {
          invalidate = true;
        }

        if (params.mode != this.copyChartParams.mode) {
          invalidate = true;
        }

        if (params.costs != this.copyChartParams.costs) {
          invalidate = true;
        }

        if (params.co2 != this.copyChartParams.co2) {
          invalidate = true;
        }

        if (params.tep != this.copyChartParams.tep) {
          invalidate = true;
        }

        if (params.rolling != this.copyChartParams.rolling) {
          invalidate = true;
        }

        if (!invalidate && data && data.sources) {
          if (params.mode == "MEASURES") {
            if (JSON.stringify(params.channels) !== JSON.stringify(this.copyChartParams.channels)) {
              invalidate = true;
            }
          } else {
            if (JSON.stringify(params.indicators) !== JSON.stringify(this.copyChartParams.indicators)) {
              invalidate = true;
            }
          }
        }

        if (this.$route.query == "dev") {
          invalidate = true;
        }

        if (!invalidate && data.values && data.values.length > 0) {
          let firstValue,
            lastValue,
            startDate,
            endDate = null;
          const format = "yyyy-MM-DD";

          if (params.sampling == "y") {
            firstValue = moment(data.values[0][0], "yyyy").format(format);
            lastValue = moment(data.values[data.values.length - 1][0], "yyyy").format(format);

            startDate = moment(params.fromYear, "yyyy").format(format);
            endDate = moment(params.toYear, "yyyy").format(format);
          } else if (params.sampling == "m") {
            firstValue = moment(data.values[0][0], format).format(format);
            lastValue = moment(data.values[data.values.length - 1][0], format).format(format);

            startDate = moment(params.fromMonth, "MM-yyyy").format(format);
            endDate = moment(params.toMonth, "MM-yyyy").format(format);
          } else {
            firstValue = moment(data.values[0][0], format).format(format);
            lastValue = moment(data.values[data.values.length - 1][0], format).format(format);

            startDate = moment(params.fromDate, format).format(format);
            endDate = moment(params.toDate, format).format(format);
          }

          if (moment(startDate).isSameOrAfter(firstValue) && moment(endDate).isSameOrBefore(lastValue)) {
            isValueNew = false;
            response = JSON.parse(JSON.stringify(this.copyChartResponse));
            if (!response.values) {
              let objectsRemoved = [];
              response[0].values = response[0].values.filter((val, idx) => {
                const date = moment(val[0], "yyyy-MM-DD").format("yyyy-MM-DD");
                if (moment(date).isSameOrAfter(startDate) && moment(date).isSameOrBefore(endDate)) {
                  return true;
                }
                objectsRemoved.push(idx);
                return false;
              });

              response[1].values = response[1].values.filter((val, idx) => {
                if (objectsRemoved.includes(idx)) {
                  return false;
                }
                return true;
              });
            } else {
              response.values = response.values.filter((item) => {
                const date = moment(item[0], "yyyy-MM-DD").format("yyyy-MM-DD");
                if (moment(date).isSameOrAfter(startDate) && moment(date).isSameOrBefore(endDate)) {
                  return true;
                }
                return false;
              });
            }
          }
        }
      }
      this.maxMonthChanged = false;
      this.filter.fromMonth = params.fromMonth;
      this.filter.toMonth = params.toMonth;
      if (isValueNew) {
        response = await this.$store.dispatch("charts/get", params);
        this.copyChartParams = { ...params };
        this.copyChartResponse = { ...response };
      }

      this.$store.commit("stopLoading");

      if (!response) {
        return false;
      }
      this.previousData = {};
      let result = { ...response };

      if (response && response[1]) {
        result = response[0];
        this.previousData = response[1];
        if (this.previousData) this.previousPeriodDates = this.previousData.values.map((value) => value[0]);
      }

      if (result) this.currentPeriodDates = result.values.map((value) => value[0]);
      return result;
    },
    getTooltipFormat(comparing) {
      let sampling = this.filter.sampling;

      if (sampling == "1" || sampling == "15" || sampling == "60") {
        return comparing
          ? '{previousDate.formatDate("MMM dd YYYY HH:mm - EEE")}'
          : '{date.formatDate("MMM dd YYYY HH:mm - EEE")}';
      }
      return comparing ? '{previousDate.formatDate("MMM dd YYYY - EEE")}' : '{date.formatDate("MMM dd YYYY - EEE")}';
    },
    getDateAxisLabelFormat(timestamp) {
      if (this.isDurationCurve) {
        return "";
      }

      let formatMonthlyYearly = "D MMM yy";
      let format1Minute = "D MMM HH:mm";
      let formatDaily = "D MMM";
      let formatMonthly = "MMM YYYY";
      let formatYearly = "YYYY";
      let sampling = this.filter.sampling;

      if (sampling == "d") {
        return moment(timestamp).format(formatDaily);
      } else if (sampling == "m") {
        return moment(timestamp).format(formatMonthly);
      } else if (sampling == "y") {
        return moment(timestamp).format(formatYearly);
      } else {
        const diff = moment(this.filter.toDate, "yyyy-MM-dd").diff(moment(this.filter.fromDate, "yyyy-MM-dd"), "days");
        if (diff > 180) {
          return moment(timestamp).format(formatMonthlyYearly);
        }
        return moment(timestamp).format(format1Minute);
      }
    },
    setDateAxis(dateAxis) {
      if (this.filter.sampling === "1") {
        dateAxis.baseInterval = {
          count: 1,
          timeUnit: "minute",
        };

        //dateAxis.groupCount = 1000;
        //dateAxis.groupData = true;
      }
      if (this.filter.sampling === "15") {
        dateAxis.baseInterval = {
          count: 15,
          timeUnit: "minute",
        };
      }
      if (this.filter.sampling === "60") {
        dateAxis.baseInterval = {
          count: 1,
          timeUnit: "hour",
        };
      }
      if (this.filter.sampling === "d") {
        dateAxis.baseInterval = {
          count: 1,
          timeUnit: "day",
        };
      }
    },
    initAggregationModeForRanges() {
      const newRangeAggregateModes = [];
      // Set default aggregate mode for each range
      this.getColumnNamesWithMeasure.forEach((rangeWithMeasure, index) => {
        const measureIndex = this.uniqueMeasures.findIndex(
          (uniqueMeasure) => uniqueMeasure === rangeWithMeasure.measure
        );
        const aggregateMode = this.measuresAggregateMode[measureIndex];

        newRangeAggregateModes[index] = aggregateMode;
      });
      this.rangeAggregateModes = newRangeAggregateModes;
    },
    tableClosed(chart) {
      chart.showTable = false;
      this.reload();
    },
    tableButtonClick(chart, index) {
      if (!index) {
        index = 0;
      }
      this.tableSeries = [];

      this.charts.forEach((c, i) => {
        c.chart.series.values.forEach((series) => {
          this.tableSeries.push({
            data: series.data.map((e) => e.value),
            name: series.name,
            unit: series.data[0].unit, // TODO are we sure unit is always on index 0
            meta: series.meta,
          });
        });
      });
      // return
      this.charts[index].showTable = true;
      if (this.reportpopupMode) {
        this.filter.actionButtons = "tableButtonClick";
      }

      if (this.filter.tableModeInverted) {
        this.propSwitchColumns = true;
      }
    },
    euroButtonClick(chart, index) {
      this.filter.costs = true;
      this.filter.co2 = false;
      this.filter.tep = false;
      this.isEnergyMode = false;
      this.isAggregateMode = false;
      this.reload();
    },
    co2ButtonClick(chart, index) {
      this.filter.co2 = true;
      this.filter.costs = false;
      this.filter.tep = false;
      this.isEnergyMode = false;
      this.isAggregateMode = false;
      this.reload();
    },
    tepButtonClick(chart, index) {
      this.filter.co2 = false;
      this.filter.tep = true;
      this.filter.costs = false;
      this.isEnergyMode = false;
      this.isAggregateMode = false;
      this.reload();
    },
    measuresButtonClick() {
      this.filter.costs = false;
      this.filter.co2 = false;
      this.filter.tep = false;
      this.isEnergyMode = true;
      this.isAggregateMode = false;
      this.reload();
    },
    unload() {
      this.seriesColorIndex = 0;
      try {
        this.charts.forEach((chart) => {
          chart.chart.dispose();
        });
        this.charts = [];
      } catch (err) {
        console.log(err);
      }
    },
    splitChart() {
      if (this.filter.compare != "no") {
        return;
      }
      //instance.options.chart.stacked = false;
      //instance.options.chart.stackType = null;
      this.filter.split = !this.filter.split;
      this.isAggregateMode = false;
      this.reload();
    },
    getDates() {
      let dates = [];
      this.currentPeriodDates.forEach((date) => {
        dates.push(date.split(" "));
      });
      return dates;
    },
    async download(type, chart) {
      chart.toolbar.open = false;
      let chartSeries = chart.chart.series.values.map((v) => v.data);
      const dates = await this.getDates();

      let aoa =
        dates[0].length === 1
          ? [["Data"], ["Totale"]]
          : [
              ["Data", "Ora"],
              ["Totale", "Totale"],
            ];
      //Building Header
      chartSeries.forEach((item) => {
        aoa[0].push(item[0].name); //Row 1: Data | <NAME> | <NAME> | ...
        let total = item.map((seriesItem) => Number(seriesItem.value)).reduce((a, b) => a + b, 0);
        aoa[1].push(total); //Row 2: Totale | <Total> | <Total> | ...
      });

      //Writing Value Rows
      for (let i = 0; i < chartSeries[0].length; i++) {
        let a = [];

        // Writing Value Columns
        chartSeries.forEach((item) => {
          let value = null;
          if (item[i] && item[i].value != null && item[i].value != undefined) {
            value = item[i].value.toString().replace(".", ",");
          }
          a.push(value).toString().split(", ");
        });

        //Prepending Date Columns
        if (dates[0].length === 1) {
          //Prepending one column in case of only date and no time
          aoa.push([moment(dates[i][0]).format("l"), ...a]);
        } else {
          //Prepending two columns in case of both date and time
          aoa.push([moment(dates[i][0]).format("l"), moment(dates[i][1], "hh:mm:ss").format("hh:mm"), ...a]);
        }
      }

      if (type === "excel") {
        const ws = XLSX.utils.aoa_to_sheet(aoa);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Sheet");
        XLSX.writeFile(wb, "export.xlsx");
      }
      if (type == "csv") {
        //converting to CSV format
        aoa.forEach((row) => {
          row.join(",");
        });

        var downloadLink = document.createElement("a");
        downloadLink.href = "data:text/csv;charset=utf-8," + encodeURI(aoa.join("\n"));
        downloadLink.download = "export-" + this.filter.sampling + ".csv";
        document.body.appendChild(downloadLink);
        downloadLink.innerHTML = "DOWNLOAD";
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    },
    async downloadTable(type, chartId) {
      const elt = document.getElementById(chartId);

      /*const clone = document.getElementById(`${chartId}-clone`);
      if(clone) {
        clone.remove();
      }
      const wrapper = document.createElement("div");
      wrapper.setAttribute("id", `${chartId}-clone`);
      wrapper.innerHTML = elt.innerHTML;
      wrapper.querySelectorAll(".data-cell").forEach(cell => {
        cell.innerHTML = cell.innerHTML.replace(/\,/, '.');
        cell.innerHTML = cell.innerHTML.replace(/'/, '');
        cell.innerHTML = cell.innerHTML.replace('⬆ ', '');
        cell.innerHTML = cell.innerHTML.replace('⬇ ', '');
      });
      wrapper.querySelectorAll(".delta-cell").forEach(cell => {
        if(cell.textContent) {
          const value = parseFloat(cell.textContent);
          cell.innerHTML = this.formatPrecision(value / 100, 4);
        }
      });

      document.querySelector("body").append(wrapper);*/

      var wb = XLSX.utils.table_to_book(elt /*wrapper.children[0]*/, {
        sheet: "Foglio 1",
        dateNF: "dd/mm/yyyy",
        cellDates: true,
        raw: false,
      });
      XLSX.writeFile(wb, "export." + (type || "xlsx"));
    },
    aggregateButton(chart, i) {
      if (!chart) {
        chart = this.charts[0];
      }
      this.rangeAggregateModes = [];
      if (this.filter.costs == true) {
        // this.filter.costs = false;
        this.isAggregateMode = true;
        this.initAggregationModeForRanges();
        // this.reload();
        if (this.isComparing) {
          this.createFxData(this.data, "new");
          this.createFxData(this.previousData, "old");
        } else {
          this.createFxData(this.data);
        }
        return;
      }

      if (this.isAggregateMode) {
        this.isAggregateMode = false;
        if (this.isComparing) {
          this.reload();
          return;
        }
        this.disposeAllSeries(chart);
        this.createSeries(this.data, chart.chart, false, {}, false);
        return;
      }
      this.isAggregateMode = true;
      if (this.isComparing) {
        this.createFxData(this.data, "new");
        this.createFxData(this.previousData, "old");
      } else {
        this.createFxData(this.data);
      }
      this.initAggregationModeForRanges();
      if (this.reportpopupMode) {
        this.filter.actionButtons = "aggregateButton";
      }
    },
    rollingButtonClick(chart, i) {
      this.filter.split = false;
      this.isAggregateMode = false;
      this.isRolling = !this.isRolling;
      this.reload();
    },
    createFxData(data, dataType) {
      let chart = this.charts[0];

      if (dataType !== "old") {
        this.disposeAllSeries(chart);
      }

      if (!data) {
        data = this.data;
      }

      const dataByMeasure = {
        columns: ["Data"],
        mus: [],
        sources: [],
        values: [],
      };

      let personlizedMeasure = _.cloneDeep(this.rangeAggregateModes);
      let mutedColumnNameWithMeasures = this.getColumnNamesWithMeasure.map((ele, i) => {
        ele.aggregateType = personlizedMeasure[i];
        return ele;
      });

      let seriesTobeCreated = {};
      this.uniqueMeasures.forEach((mu, umIndex) => {
        // let mu = kwh, now collect all data for kWH
        let aggregateType = this.measuresAggregateMode[umIndex];
        dataByMeasure.mus.push(mu);
        dataByMeasure.sources.push("ELE001_01" + umIndex);

        if (aggregateType == "mul") {
          dataByMeasure.sources = data.sources;
          dataByMeasure.mus = data.mus;
        }

        let seriesName = null;
        if (aggregateType == "sum") {
          seriesName = "Somma - ";
        } else if (aggregateType == "avg") {
          seriesName = "Media - ";
        } else if (aggregateType == "mul") {
          seriesName = "Moltiplica - ";
        }
        let MuIndexes = [];

        // loop for each measure unit
        data.mus.forEach((dm, i) => {
          // check aggregate.type of column related to this dm
          let cAggre = mutedColumnNameWithMeasures.find((ele) => ele.name == data.columns[i + 1]);
          // dm = measure unit, mu = measure unit
          if (dm == mu) {
            if (
              cAggre.aggregateType == undefined ||
              (cAggre.aggregateType == aggregateType && aggregateType != "mul")
            ) {
              //measuresAggregateMode
              MuIndexes.push(Number(i));
              if (aggregateType == "mul") {
                dataByMeasure.columns.push(data.columns[i + 1]);
              } else {
                seriesName += data.columns[i + 1] + ",";
              }
            } else {
              //rangeAggregateModes
              let aggreType = cAggre.aggregateType == "" ? "none" : cAggre.aggregateType;
              if (seriesTobeCreated[aggreType]) {
                seriesTobeCreated[aggreType].push(cAggre);
              } else {
                seriesTobeCreated[aggreType] = [cAggre];
              }
            }
          }
        });

        // ORIGINAL: seriesName = seriesName.replace(/.$/,")");
        seriesName = seriesName.replace(/.$/, "");
        data.values.forEach((value, nIndex) => {
          let totalValue = 0;
          // loop to set data.value in totalValue
          for (let i = 0; i < value.length; i++) {
            if (MuIndexes.includes(i)) {
              totalValue += value[i + 1];
            }
          }

          // ORIGNAL: const calculatedValue = aggregateType == 'sum' ? totalValue : totalValue / MuIndexes.length;
          let calculatedValue = null;
          if (aggregateType == "sum") {
            calculatedValue = totalValue;
          } else if (aggregateType == "avg") {
            calculatedValue = totalValue / MuIndexes.length;
          } else if (aggregateType == "mul") {
            let arrayValues = [value[0]];
            for (let i = 1; i < value.length; i++) {
              arrayValues.push(value[i] * this.multiplier);
            }
            dataByMeasure.values.push(arrayValues);
          }
          if (aggregateType != "mul") {
            if (dataByMeasure.values[nIndex]) {
              dataByMeasure.values[nIndex].push(calculatedValue);
            } else {
              dataByMeasure.values.push([value[0], calculatedValue]);
            }
          }
        });

        if (aggregateType != "mul") {
          dataByMeasure.columns.push(seriesName);
        }
      });

      // to set up columns correctly
      if (seriesTobeCreated["mul"] && seriesTobeCreated["mul"].length > 1) {
        dataByMeasure.columns = ["Data"];
        seriesTobeCreated["mul"].forEach((item) => {
          dataByMeasure.columns.push("Moltiplica - " + item.name);
        });
      } else if (seriesTobeCreated["mul"]) {
        let position = null;
        for (let i = 0; i < this.multiplierAggregateModes.length; i++) {
          if (this.multiplierAggregateModes[i]) {
            position = i;
          }
        }
        dataByMeasure.columns[position + 1] = "Moltiplica - " + data.columns[position + 1];
      }

      // to set up columns correctly
      if (seriesTobeCreated["none"] && seriesTobeCreated["none"].length > 1) {
        dataByMeasure.columns = ["Data"];
        seriesTobeCreated["none"].forEach((item) => {
          dataByMeasure.columns.push("Nessuna - " + item.name);
        });
      } else if (seriesTobeCreated["none"]) {
        let position = null;
        data.columns.forEach((item, colIndex) => {
          if (item == seriesTobeCreated["none"][0].name) {
            position = colIndex;
          }
        });
        dataByMeasure.columns[position] = "Nessuna - " + data.columns[position];
      }

      if (
        seriesTobeCreated["sum"] ||
        seriesTobeCreated["avg"] ||
        seriesTobeCreated["mul"] ||
        seriesTobeCreated["none"]
      ) {
        dataByMeasure.mus = [];
        dataByMeasure.sources = [];
      }

      if (seriesTobeCreated["sum"] || seriesTobeCreated["avg"]) {
        dataByMeasure.values = [];
      }

      if (seriesTobeCreated != {}) {
        for (let key in seriesTobeCreated) {
          this.uniqueMeasures.forEach((mu, umIndex) => {
            if (key == "mul" || key == "none") {
              let position = null;
              for (let i = 0; i < seriesTobeCreated[key].length; i++) {
                //to find position
                data.columns.forEach((item, index) => {
                  if (seriesTobeCreated[key].length == 1) {
                    if (item == seriesTobeCreated[key][0].name) {
                      position = index;
                    }
                  } else {
                    if (item == seriesTobeCreated[key][i].name) {
                      position = index;
                    }
                  }
                });

                //to set up dataByMeasure.values once
                if (dataByMeasure.values.length < 1) {
                  dataByMeasure.values = data.values;
                }

                if (key == "mul") {
                  data.values.forEach((value, dataVIndex) => {
                    dataByMeasure.values[dataVIndex][position] =
                      value[position] * this.multiplierAggregateModes[position - 1];
                  });
                } else {
                  data.values.forEach((value, dataVIndex) => {
                    dataByMeasure.values[dataVIndex][position] = value[position];
                  });
                }
                dataByMeasure.mus.push(mu);
                dataByMeasure.sources.push(data.sources[position - 1]);
              }
            } else {
              let filteredSeries = seriesTobeCreated[key].filter((ele) => ele.measure == mu);

              // here create a new series particularly for this measure and mu
              let meaMuSeriesName = "";
              if (key == "sum") {
                meaMuSeriesName = "Somma - ";
              } else if (key == "avg") {
                meaMuSeriesName = "Media - ";
              }

              if (filteredSeries.length) {
                dataByMeasure.mus.push(mu);
                dataByMeasure.sources.push("diffSeries" + key + mu + umIndex);
              }

              let MuIndexes = filteredSeries.map((e) => e.indexInData);
              let joinedNames = filteredSeries.map((e) => e.name).join();
              meaMuSeriesName += joinedNames;

              data.values.forEach((value, nIndex) => {
                let totalValue = 0;
                for (let i = 0; i < value.length; i++) {
                  if (MuIndexes.includes(i)) {
                    totalValue += value[i];
                  }
                }

                var calculatedValue = key == "sum" || key == "none" ? totalValue : totalValue / MuIndexes.length;

                if (dataByMeasure.values[nIndex]) {
                  dataByMeasure.values[nIndex].push(calculatedValue);
                } else {
                  dataByMeasure.values.push([value[0], calculatedValue]);
                }
              });

              let position = null;
              data.columns.forEach((item, colIndex) => {
                if (item == seriesTobeCreated[key][0].name) {
                  position = colIndex;
                }
              });

              if (filteredSeries.length) {
                dataByMeasure.columns[position] = meaMuSeriesName;
              }
            }
          });
        }
      }

      if (dataType == "new") {
        this.newCalculatedData = dataByMeasure;
      } else if (dataType == "old") {
        this.createSeries(this.newCalculatedData, chart.chart, false, dataByMeasure, false);
        this.createSeries(dataByMeasure, chart.chart, true, this.newCalculatedData, false);
      }

      if (!this.isComparing || !dataType) {
        this.createSeries(dataByMeasure, chart.chart, false, {}, false);
      }
    },
    disposeAllSeries(chart) {
      let l = Number(chart.chart.series.values.length);
      for (let i = 0; i < l; i++) {
        chart.chart.series.removeIndex(0).dispose();
      }
      this.seriesColorIndex = 0;
    },
    checkChartForReports() {
      if (this.reportMode && this.filter.actionButtons) {
        this[this.filter.actionButtons]();
      }
      if (this.reportpopupMode == "table") {
        this.tableButtonClick();
      }
    },
  },
  computed: {
    ...mapState({
      sites: (state) => state.user.sites,
      user: (state) => state.user,
    }),
    hasElasticData() {
      return this.user.hasElasticData;
    },
    showStackFun() {
      let mus = this.data.mus;
      let length = this.data.columns.length;
      let uniq = [...new Set(mus)];
      if (uniq.length > 1 || length < 3) {
        return false;
      }

      return true;
    },
    getColumnNamesWithMeasure() {
      return this.data.mus.map((ele, i) => {
        return {
          name: this.data.columns[i + 1],
          measure: ele,
          indexInData: i + 1,
        };
      });
    },
    formattedCharts() {
      return this.charts;
    },
    isComparing() {
      return this.filter.compare !== "no";
    },
    tableDates() {
      return {
        previousPeriodDates: this.previousPeriodDates,
        currentPeriodDates: this.currentPeriodDates,
      };
    },
    uniqueMeasures() {
      return [...new Set(this.channels.map((item) => item.mu))];
    },
    isIndicators() {
      return this.filter.mode === "INDICATORS";
    },
    checkChartHeight() {
      if (this.reportMode) {
        return "100%";
      } else if (this.filter.split) {
        return "350px";
      } else {
        return "500px";
      }
    },
  },
  watch: {
    thresholds() {
      this.reload();
    },
    maxMonth() {
      this.maxMonthChanged = true;
      this.reload();
    },
    filter(value, lastvalue) {
      if (value.channels.length != lastvalue.channels.length) {
        if (this.isAggregateMode) {
          this.isAggregateMode = false;
          this.isRecheckAggregateMode = true;
        }
      } else {
        this.isRecheckAggregateMode = false;
      }

      debounce(this.reload, 10)();
    },
    measuresAggregateMode() {
      this.isAggregateMode = false;
      this.aggregateButton();
    },
    multiplier() {
      this.isAggregateMode = false;
      this.aggregateButton();
    },
  },
  beforeDestroy() {
    this.unload();
  },
};
</script>

<style>
.threshold-button {
  height: 40px;
  width: 40px;
}

.white {
  color: white !important;
}

.average-number {
  max-width: 120px;
  display: inline-block;
}

.full-chart {
  height: 500px;
}

.amcharts-amexport-item > a {
  text-decoration: none;
}

.amcharts-amexport-item > a:active,
.amcharts-amexport-item > a:hover {
  text-decoration: none;
  color: #333;
}

.download_dropdown .btn,
.download_dropdown .btn:hover {
  background: white;
  border: 0px;
}

.aggregate-selection-block {
  margin-left: 70px;
  width: 500px;
}

.aggregate-selection {
  display: flex;
  margin-bottom: 10px;
}

.aggregate-selection:last-child {
  margin-bottom: 0;
}

.aggregate-selection-label {
  min-width: 70px;
  font-size: 18px;
}

.button_container {
  display: flex;
  justify-content: flex-end;
}

.vs__dropdown-menu {
  z-index: 4000;
}

.aggregate-header {
  background: #cf5651;
  color: white;
}

.aggregate-body {
  background: #f0f3f6;
}

.aggregate-input-number {
  width: 80px;
}

.average-button {
  position: relative;
}

.dot {
  position: absolute;
  top: 0;
  right: 0;
  font-size: 12px;
}

.btn-default.selected {
  border-bottom: 3px solid #cf5651;
}
</style>



// WEBPACK FOOTER //
// src/components/Charts/Types/Am/Line.vue